var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M4 2h8M4 3h8M2 4h2m8 0h2M2 5h2m8 0h2M0 6h2m12 0h2M0 7h2m12 0h2M0 8h2m12 0h2m2 0h2M0 9h2m12 0h2m2 0h2M0 10h2m12 0h2m2 0h4M0 11h2m12 0h2m2 0h4M0 12h2m12 0h6m2 0h2M0 13h2m12 0h6m2 0h2M0 14h2m12 0h2m8 0h2M0 15h2m12 0h2m8 0h2M0 16h2m12 0h2m8 0h2M0 17h2m12 0h2m8 0h2M2 18h2m8 0h8m2 0h2M2 19h2m8 0h8m2 0h2M4 20h8m6 0h4M4 21h8m6 0h4m-4 1h2m-2 1h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f7c42a",
    d: "M4 4h8M4 5h8M2 6h12M2 7h12M4 8h8M4 9h8m-6 1h2m-2 1h2m-2 3h2m-2 1h2m-2 3h2m-2 1h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f7971b",
    d: "M2 8h2m8 0h2M2 9h2m8 0h2M4 10h2m2 0h4m-8 1h2m2 0h4M2 12h2m8 0h2M2 13h2m8 0h2M4 14h2m2 0h4m-8 1h2m2 0h4M2 16h2m8 0h2M2 17h2m8 0h2M4 18h2m2 0h4m-8 1h2m2 0h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ce5906",
    d: "M2 10h2m8 0h2M2 11h2m8 0h2M4 12h8m-8 1h8M2 14h2m8 0h2M2 15h2m8 0h2M4 16h8m-8 1h8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#20d829",
    d: "M20 12h2m-2 1h2m-4 1h4m-4 1h4m-6 1h4m-4 1h4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#93ff70",
    d: "M16 14h2m-2 1h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00bc12",
    d: "M22 14h2m-2 1h2m-4 1h4m-4 1h4m-4 1h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.7dd74e564aaf67a82aac025c46ab224a.svg";
export { ForwardRef as ReactComponent };